/*
  LandingPage.js
  This component's only job is to assemble all the sections
  that make up our main landing page.
*/
import React from 'react';

// Import all our sections
import Hero from '../../components/sections/Hero/Hero';
import Section2 from '../../components/sections/Section2/Section2';
import Section3 from '../../components/sections/Section3/Section3';
import Section4 from '../../components/sections/Section4/Section4';
import Section5 from '../../components/sections/Section5/Section5';
import Section6 from '../../components/sections/Section6/Section6';
import Section7 from '../../components/sections/Section7/Section7';
import Section8 from '../../components/sections/Section8/Section8';
import Section9 from '../../components/sections/Section9/Section9';
import Section10 from '../../components/sections/Section10/Section10';
import Section11 from '../../components/sections/Section11/Section11';
import Footer from '../../components/common/Footer/Footer';
//import Footer from '../components/common/Footer/Footer';
// We will add Section3, Section4, etc. here

function LandingPage() {
  document.title = "Home | Dandelion Run Community";
  return (
    // We use a React "Fragment" (<> ... </>) to hold them
    <>
      <Hero />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
      <Section9 />
      <Section10 />
      <Section11 />
      <Footer />
      
      

    </>
  );
}

export default LandingPage;